<template>
  <v-container class="limited">
    <dados-beneficiario></dados-beneficiario>
    <demonstrativo :codigo-beneficiario="dadosBeneficiario.id"></demonstrativo>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import DadosBeneficiario from "@/components/BeneficiaryData";
import Demonstrativo from "./demonstrativo";

const { mapState } = createNamespacedHelpers("beneficiario");

export default {
  name: "DemonstrativoIr",
  components: {
    DadosBeneficiario,
    Demonstrativo
  },
  computed: mapState(["dadosBeneficiario"])
};
</script>
